import React from "react";
import gettext from "../../shared/utils/gettext";
import NavLink from "./NavLink";
import Aside from "./Aside";
import { useForceUpdateOnCroprEvent } from "./hooks";

const icons: Record<string, string> = { research: "fa-microscope", soil: "fa-microscope" };

const AsidePartner = () => {
  const { partner_config: partner } = useForceUpdateOnCroprEvent("init");
  if (!partner) return null;
  return (
    <Aside>
      {partner.menu_items.map((item: any) => {
        const name = item[0].substring(1);
        return (
          <NavLink
            show
            key={item[0]}
            title={item[1]}
            to={[`/apps/${partner.app_name.toLowerCase()}/admin/${item[0]}`]}
            exact
          >
            <i className={`far ${icons[name] || "icn_" + name} fa-lg`} />
            <span>{item[1]}</span>
          </NavLink>
        );
      })}
      <NavLink
        title={gettext("Settings")}
        to={[`/apps/${partner.app_name.toLowerCase()}/admin/color_configuration/`]}
        show={partner.app_name.toLowerCase() === "farmfrites"}
      >
        <i className="far icn_settings fa-lg" />
        <span>{gettext("Settings")}</span>
      </NavLink>
      <NavLink
        title={gettext("Upload images")}
        to={[`/apps/${partner.app_name.toLowerCase()}/bulk_upload_images/`]}
        show={partner.app_name.toLowerCase() === "sensus"}
      >
        <i className="far fa-upload fa-lg" />
        <span>{gettext("Upload images")}</span>
      </NavLink>
      <NavLink
        title={gettext("Configuration")}
        to={[`/apps/${partner.app_name.toLowerCase()}/admin/configuration/`]}
        show={!partner.is_supplier || partner.contracts}
      >
        <i className="far icn_config fa-lg" />
        <span>{gettext("Configuration")}</span>
      </NavLink>
      <NavLink
        title={gettext("Users")}
        to={[`/apps/${partner.app_name.toLowerCase()}/admin/users/`]}
        show
      >
        <i className="far icn_user fa-lg" />
        <span>{gettext("Users")}</span>
      </NavLink>
    </Aside>
  );
};

export default AsidePartner;
